module.exports = __webpack_public_path__ + "static/media/Pokeball-PNG.fc273ffe.png";